import {Typography} from '@mui/material';
import {t} from 'i18next';
import {
  convertBinaryToPDF,
  convertDateStringToObject,
  formateNumber,
  getCurrencySymbol,
  getLocalFormatedDate,
  getUTCDateTimeForDisplay,
} from '../../../utils/utils';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import AurButton from '../../common/aur-button/AurButton';

import {GridSortModel} from '@mui/x-data-grid';
import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReactComponent as ExchangeIcon} from '../../../../src/assests/svg/icon_shift.svg';
import {
  getInvoiceDownload,
  getInvoiceList,
} from '../../../api/ReportingManagement';
import {
  getInvoiceAlerts,
  getOverviewProjects,
  updateAlertStatusAsViewed,
} from '../../../api/UserManagementService';
import {
  CUSTOM_REPORT_COL_HEIGHT,
  failedToLoadStatusCodes,
  INVOICE_REPORT_GRID_ERROR_COMPONENT,
  MIN_SEARCH_CHAR,
  MODAL_PROJECT_DROP_DOWN_ID,
  ONLY_DATE_SHOW_FORMAT,
  POPUP_BUTTON_STYLE,
  TABLE_PAGE_SIZE_OPTION,
  TABLE_PER_PAGE_DEFAULT_50_ROW,
  TABLE_PER_PAGE_DEFAULT_NO_ROW,
} from '../../../constants/constants';
import {setAlerts} from '../../../redux/slices/alertSlice';
import {
  setModalDropDownSelectedItem,
  setModalStatus,
} from '../../../redux/slices/invoiceModalSlice';
import {RootState} from '../../../redux/store';
import {ViewInvoicesData} from '../../../types/types';
import {getViewInvoicesTableColumns} from '../../../utils/viewInvoiceUtils';
import AurAlertCarousel from '../../common/aur-alert/AurAlertCarousel';
import AurDataGrid from '../../common/aur-data-grid/AurDataGrid';
import DateRangePicker from '../../common/aur-date-range-picker/AurDateRangePicker';
import AurPopup from '../../common/aur-popup/AurPopup';
import AurSearchBox from '../../common/aur-search-box/AurSearchBox';
import AurClientDropdown from '../../client-management/aur-client-dropdown/AurClientDropdown';
import AurLoadingIndicator from '../../common/aur-loading-indicator/AurLoadingIndictor';
import AurDataGridErrorOverlay from '../../common/aur-data-grid-error-overlay/AurDataGridErrorOverlay';
import AurDataGridLoadingOverlay from '../../common/aur-data-grid-loading-overlay/AurDataGridLoadingOverlay';
import {useToast} from '../../../contexts/toastContext/ToastContext';
import {noop, unionBy} from 'lodash';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';
import {setReportSrc} from '../../../redux/slices/analyticsSlice';
import {
  GA_CLICK_TYPES,
  GA_DATA_MODE_AUTO,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_REPORT_TYPE,
} from '../../../constants/analyticsConstants';
import {useAnalytics} from '../../../hooks/useAnalytics';

const PROJECT_LIST_SEARCH_ENABLE_COUNT = 12;
const MAX_MIN_DECIMAL_VALUE = 2;
const PROJECT_PAGE_SIZE = 100;

const ViewInvoices = () => {
  const [fromDate, setFromDate] = useState(
    getLocalFormatedDate(
      new Date(new Date().setMonth(new Date().getMonth() - 2))
    )
  );
  const [toDate, setToDate] = useState(getLocalFormatedDate(new Date()));
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [currentPageGrid, setCurrentPageGrid] = useState<number>(1);
  const [itemsPerPageGrid, setItemsPerPageGrid] = useState<number>(
    TABLE_PER_PAGE_DEFAULT_NO_ROW
  );
  const [rows, setRows] = useState<ViewInvoicesData[]>([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [dropDownProjects, setDropDownProjects] = useState<
    Array<Record<string, any>>
  >([]);
  const [initialProjectListLoading, setInitialProjectListLoading] =
    useState<boolean>(true);
  const [projectListLoading, setProjectListLoading] = useState<boolean>(false);
  const [projectListSearchEnable, setProjectListSearchEnable] =
    useState<boolean>(false);
  const [sortModel, setSortModel] = useState<GridSortModel>([
    {field: 'invoiceDate', sort: 'desc'},
  ]);
  const [initialStartDate, setInitialStartDate] = useState({
    year: '',
    month: '',
    day: '',
  });
  const [initialEndDate, setInitialEndDate] = useState({
    year: '',
    month: '',
    day: '',
  });
  const [isGetInvoiceLoading, setIsGetInvoiceLoading] = useState(false);
  const [isDownloadInvoiceLoading, setIsDownloadInvoiceLoading] =
    useState(false);
  const pickedProjectFromDropdown = useRef<any | undefined>(undefined);
  const tableContainerRef = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState(
    (tableContainerRef.current?.offsetHeight ?? 500) +
      INVOICE_REPORT_GRID_ERROR_COMPONENT
  );
  const [isGetAlertLoading, setIsGetAlertLoading] = useState(false);
  const [isFailedToLoadInvoice, setIsFailedToLoadInvoice] =
    useState<boolean>(false);
  const [isFailedToLoadAlert, setIsFailedToLoadAlert] =
    useState<boolean>(false);
  const [isFetchInvoiceInitial, setIsFetchInvoiceInitial] = useState(true);
  const {showToast} = useToast();
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const {trackGAEvent} = useAnalytics();

  const apiResponseTime = useRef('');

  /**
   * To get datagrid height
   */
  useEffect(() => {
    const updateHeight = () => {
      if (tableContainerRef.current) {
        setSize(
          tableContainerRef.current.offsetHeight - CUSTOM_REPORT_COL_HEIGHT
        );
      }
    };
    window.addEventListener('resize', updateHeight);
    updateHeight();

    return () => window.removeEventListener('resize', updateHeight);
  });

  const dispatch = useDispatch();

  const selectedClient = useSelector(
    (state: RootState) => state.selectedClient
  );

  const projects = useSelector(
    (state: RootState) => state.clientReducer[MODAL_PROJECT_DROP_DOWN_ID]
  );

  const modalStatus = useSelector(
    (state: RootState) => state.invoiceModal.modalIsOpen
  );

  const refreshDates = useSelector(
    (state: RootState) => state.reports.refreshDates
  );

  const selectedProject = useSelector(
    (state: RootState) => state.invoiceModal.modalDropDownSelectedItem
  );
  const projectId = projects?.selectedOption;

  const projectName = projects?.options.find(
    (opt) => opt.id === projects?.selectedOption
  )?.display;

  const [displayProjectName, setDisplayProjectName] = useState<string>(
    selectedProject.name
  );
  const [viewInvoicesProjectId, setViewInvoicesProjectId] = useState<
    string | null
  >(selectedProject.id);
  const modalContinueHandler = () => {
    dispatch(
      setModalDropDownSelectedItem(
        projects.selectedOption && projects.selectedOptionLable
          ? {id: projects.selectedOption, name: projects.selectedOptionLable}
          : {id: '', name: ''}
      )
    );
    dispatch(setModalStatus(false));
    setDisplayProjectName(projectName);
    setViewInvoicesProjectId(projectId);
  };
  const modalCancelHandler = () => {
    pickedProjectFromDropdown.current = dropDownProjects.find(
      (item) => item.projectId === viewInvoicesProjectId
    );
    dispatch(setModalStatus(false));
  };

  const clientName = selectedClient?.name;
  const clientId = selectedClient?.clientId;

  const alertData = useSelector((state: RootState) => state.alerts);
  const fetchData = async () => {
    setIsGetAlertLoading(true);
    try {
      setIsFailedToLoadAlert(false);
      const responseFetchAlert = await getInvoiceAlerts(
        clientId!,
        viewInvoicesProjectId!
      );
      dispatch(setAlerts(responseFetchAlert?.data?.data));
    } catch (error: any) {
      if (failedToLoadStatusCodes.includes(error.status))
        setIsFailedToLoadAlert(true);
    } finally {
      setIsGetAlertLoading(false);
    }
  };
  useEffect(() => {
    if (viewInvoicesProjectId && clientId) fetchData();
  }, [clientId, viewInvoicesProjectId]);

  useEffect(() => {
    if (modalStatus) {
      setTimeout(() => {
        const projectButton = document.querySelector(
          '[data-testid="project-dropdown-button"]'
        ) as HTMLElement;
        if (projectButton) projectButton.focus();
      }, 150);
    }
  }, [modalStatus]);

  const markAlertAsViewed = (userAlertId: number) => {
    updateAlertStatusAsViewed(userAlertId)
      .then(() => {
        fetchData();
      })
      .catch(noop);
  };
  const fetchInvoices = async () => {
    setIsGetInvoiceLoading(true);
    try {
      setIsFailedToLoadInvoice(false);
      const paramString = `?clientId=${clientId}&projectId=${viewInvoicesProjectId}&toDate=${toDate}&fromDate=${fromDate}&SearchTerm=${searchTerm}&pageNumber=${currentPageGrid}&pageSize=${itemsPerPageGrid}`;

      const result = await getInvoiceList(paramString);
      apiResponseTime.current = result.data.responseTime;
      const invoices = result.data.data.map(
        (invoice: ViewInvoicesData, index: number) => ({
          ...invoice,
          id: index,
          invoiceDate: getUTCDateTimeForDisplay(
            invoice.invoiceDate,
            ONLY_DATE_SHOW_FORMAT
          ),
          invoiceAmount:
            getCurrencySymbol(invoice.currencyCode) +
            formateNumber(invoice.invoiceAmount, {
              maximumFractionDigits: MAX_MIN_DECIMAL_VALUE,
              minimumFractionDigits: MAX_MIN_DECIMAL_VALUE,
            }) +
            ' ' +
            invoice.currencyCode,
        })
      );
      setRows(invoices);
      const totalInvoices = result.data.meta.pagination.totalItems;
      if (
        isFetchInvoiceInitial &&
        totalInvoices > TABLE_PER_PAGE_DEFAULT_50_ROW
      ) {
        setItemsPerPageGrid(TABLE_PER_PAGE_DEFAULT_50_ROW);
        setIsFetchInvoiceInitial(false);
      }
      setTotalRowCount(totalInvoices);
    } catch (error: any) {
      setRows([]);
      if (failedToLoadStatusCodes.includes(error.status)) {
        setIsFailedToLoadInvoice(true);
      }
      apiResponseTime.current = (error as any).responseTime;
    } finally {
      setIsGetInvoiceLoading(false);

      trackGAEvent({
        eventName: GA_EVENT_NAMES.PAGE_VIEW,
        page: GA_DATA_MODE_AUTO,
        user: GA_DATA_MODE_AUTO,
        report: {
          name: t('gaTracking.reports.viewInvoices.invoiceBreadCrumb'),
          type: GA_REPORT_TYPE.STANDARD,
          load_time: apiResponseTime.current,
        },
      });
    }
  };
  useEffect(() => {
    fetchInvoices();
    setInitialStartDate(convertDateStringToObject(fromDate));
    setInitialEndDate(convertDateStringToObject(toDate));
  }, [
    itemsPerPageGrid,
    currentPageGrid,
    searchTerm,
    sortModel,
    fromDate,
    toDate,
    displayProjectName,
    viewInvoicesProjectId,
  ]);
  const isDateRangeReady =
    initialStartDate.year !== '' && initialEndDate.year !== '';

  const downloadInvoice = async (invoiceId: string) => {
    const paramString = `?clientId=${clientId}&projectId=${viewInvoicesProjectId}`;
    const result = await getInvoiceDownload(invoiceId, paramString);
    const pdfUrl = await convertBinaryToPDF(result.data.data.data);
    return pdfUrl; // Return the PDF URL
  };
  const handlePrintClick = async (invoiceLink: string) => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('viewInvoices.ga.print'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action: t('viewInvoices.ga.printInvoiceReport'),
      },
    });
    try {
      setIsDownloadInvoiceLoading(true);
      const invoiceId = invoiceLink.split('=')[1];
      const pdfUrl = await downloadInvoice(invoiceId ?? '');

      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      iframe.src = pdfUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow?.print();
      };
    } catch (e) {
      showToast(
        t('viewInvoices.documentPrintFailed'),
        'error',
        undefined,
        'center'
      );
    } finally {
      setIsDownloadInvoiceLoading(false);
    }
  };

  // Function to handle download click
  const handleDownloadClick = async (
    invoiceLink: string,
    invoiceNumber: string
  ) => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('viewInvoices.ga.download'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action: t('viewInvoices.ga.donwloadInvoiceReport'),
      },
    });
    try {
      setIsDownloadInvoiceLoading(true);
      // Split the string by '=' and get the part after it
      const invoiceId = invoiceLink.split('=')[1];
      const pdfUrl = await downloadInvoice(invoiceId ?? '');
      // Save the PDF with the invoice ID as the file name
      const a = document.createElement('a');
      a.href = pdfUrl;
      a.download = `${invoiceNumber}.pdf`; // Set the filename for the downloaded PDF
      a.click(); // Trigger the download
    } catch (e) {
      showToast(
        t('viewInvoices.documentDownloadFailed'),
        'error',
        undefined,
        'center'
      );
    } finally {
      setIsDownloadInvoiceLoading(false);
    }
  };
  const columns = getViewInvoicesTableColumns(
    handlePrintClick,
    handleDownloadClick
  );

  const handleOnDateChange = (start: string, end: string) => {
    dispatch(setReportSrc(GA_REGIONS.BODY));
    setFromDate(start);
    setToDate(end);
  };
  const getBreadcrumbItems = () => {
    const baseItems = [
      {
        label: t('reports.projectOverview.label'),
        path: '/welcome-single-client',
      },
      {label: t('viewInvoices.invoiceBreadCrumb')},
    ];

    return baseItems;
  };

  const items = getBreadcrumbItems();
  const handleSearchChange = (search: string) => {
    setSearchTerm(search);
  };
  const onSetSortModel = (sortModel: GridSortModel) => {
    setSortModel(sortModel);
  };

  // Fetch Projects

  const prevProjectInput = useRef<{
    searchInput: string | undefined;
    page: number;
    reset: boolean;
  }>({searchInput: undefined, page: 1, reset: false});

  const fetchProjectList = async (
    searchInput?: string,
    page = 1,
    reset = false
  ) => {
    if (
      prevProjectInput.current.searchInput === searchInput &&
      prevProjectInput.current.page === page &&
      prevProjectInput.current.reset === reset
    ) {
      setInitialProjectListLoading(false);
      return;
    }

    prevProjectInput.current = {searchInput, page, reset};

    if (page === 1) {
      setProjectListLoading(true);
    } else {
      setIsLoadingMore(true);
    }

    try {
      let queryParam = `clientId=${clientId}&pageSize=${PROJECT_PAGE_SIZE}&pageNumber=${page}`;
      if (searchInput) queryParam += `&SearchTerm=${searchInput}`;
      const body = JSON.stringify({
        branches: [],
        departments: [],
        entities: [],
      });
      const response = await getOverviewProjects(
        selectedClient.clientId,
        body,
        queryParam
      );

      const fetchedProjects = response.data.data;
      setHasMore(fetchedProjects.length === PROJECT_PAGE_SIZE);

      const newProjectList = reset
        ? fetchedProjects
        : unionBy([...dropDownProjects, ...fetchedProjects], 'projectId');

      if (
        dropDownProjects.length === 0 &&
        fetchedProjects.length >= PROJECT_LIST_SEARCH_ENABLE_COUNT &&
        !projectListSearchEnable
      ) {
        setProjectListSearchEnable(true);
      }

      setDropDownProjects(newProjectList);
    } catch (error) {
      console.error('Error fetching ECA projects', error);
    } finally {
      setProjectListLoading(false);
      setIsLoadingMore(false);
      setInitialProjectListLoading(false);
    }
  };

  const loadMoreProjects = () => {
    if (!hasMore || isLoadingMore) return;
    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    fetchProjectList(searchTerm, nextPage);
  };
  const handleProjectSearch = (input: string) => {
    setSearchTerm(input);
    setPageNumber(1);
    fetchProjectList(input, 1, true);
  };

  useEffect(() => {
    if (modalStatus && clientId) {
      setInitialProjectListLoading(true);
      fetchProjectList('', 1, true);
    }
  }, [modalStatus, clientId]);

  const projectButtonHandler = () => {
    dispatch(setModalStatus(true));
  };

  useEffect(() => {
    dispatch(setModalStatus(false));
  }, []);

  return (
    <div className="view-invoices">
      <div className="view-invoices-main">
        <div className="view-invoices-breadcrumb-section">
          <AurBreadcrumb items={items} />
        </div>
        <div className="view-invoices-header">
          <div>
            <Typography className="typo-text subhead3_size">
              {clientName}
            </Typography>
          </div>
          <div className="view-invoices-sub-title">
            <Typography className="typo-text display3_size">
              {displayProjectName}
            </Typography>
            <AurButton
              classNames="typo-text buttonMedium_size"
              type="continue"
              size="Medium"
              startIcon={<ExchangeIcon aria-hidden={true} />}
              onClick={projectButtonHandler}
              dataTestId="project-button"
              ariaLabel={t('viewInvoices.changeProjectButtonHint')}
            >
              {t('viewInvoices.projectButton')}
            </AurButton>
          </div>

          <div className="view-invoices-date-section">
            <Typography className="typo-text body3_size">
              {t('viewInvoices.dateAsOf')}{' '}
              <AurLightTooltip title={t('common.yearMonthDate')}>
                <span className="typo-text label1_size view-invoices-date-sub-section">
                  {getUTCDateTimeForDisplay(
                    refreshDates?.invoice || new Date()
                  )}
                </span>
              </AurLightTooltip>
            </Typography>
          </div>
        </div>
      </div>
      <div className="view-invoices-detail">
        <Typography className="typo-text subhead1_size content-heading">
          {t('viewInvoices.recentInvoices')}
        </Typography>
        {isGetAlertLoading ? (
          <div className="alert-loading">
            <AurLoadingIndicator />
          </div>
        ) : isFailedToLoadAlert ? (
          <div className="alert-error">
            <AurDataGridErrorOverlay
              onRefresh={fetchData}
              enableParentWrapper={false}
            />
          </div>
        ) : alertData?.alerts?.length > 0 ? (
          <div className="view-invoices-alert" data-testid="alert">
            <AurAlertCarousel
              alertsData={
                alertData?.alerts.map((alert) => ({
                  ...alert,
                  deleteButtonHandler: () =>
                    markAlertAsViewed(alert.userAlertId),
                })) as []
              }
            />
          </div>
        ) : null}
        <div className="content">
          <div className="search-and-date">
            <AurSearchBox
              label={t('common.searchInvoices')}
              onSearch={handleSearchChange}
              hintText={t('viewInvoices.searchInvoiceHint')}
              minCharForSearch={MIN_SEARCH_CHAR}
            />
            <div className="date-box">
              {isDateRangeReady && (
                <>
                  <Typography className="typo-text body2_size mist-400">
                    {t('viewInvoices.selectDateRange')}
                  </Typography>

                  <DateRangePicker
                    onDateChange={handleOnDateChange}
                    initialStartDate={{
                      year: initialStartDate.year,
                      month: initialStartDate.month,
                      day: initialStartDate.day,
                    }}
                    initialEndDate={{
                      year: initialEndDate.year,
                      month: initialEndDate.month,
                      day: initialEndDate.day,
                    }}
                    shouldShowApplyButton={true}
                  />
                </>
              )}
            </div>
          </div>
          <span id={'table-info-id'} style={{display: 'none'}}>
            {t('accessibility.table.invoiceList', {name: displayProjectName})}
          </span>
          <AurDataGrid
            columns={columns}
            rows={rows}
            pageSizeOptions={TABLE_PAGE_SIZE_OPTION}
            checkBoxVisible={false}
            entityType={'invoices'}
            visibleToolTip={true}
            className="viewInvoicesTable"
            currentPage={currentPageGrid}
            setCurrentPage={setCurrentPageGrid}
            itemsPerPage={itemsPerPageGrid}
            setItemsPerPage={setItemsPerPageGrid}
            sortModel={sortModel}
            setSortModel={onSetSortModel}
            totalRowCount={totalRowCount}
            onRefresh={fetchInvoices}
            containerHeight={size}
            aria-labelledby="table-info-id"
            noRowsOverlay={
              isGetInvoiceLoading
                ? AurDataGridLoadingOverlay
                : isFailedToLoadInvoice
                  ? AurDataGridErrorOverlay
                  : undefined
            }
            headerSpanTabIndex={-1}
            defaultHeaderCellTabIndex={-1}
            disableHeaderRowTabIndex
          />
          <AurPopup
            open={modalStatus}
            onOk={modalContinueHandler}
            className="find-invoice-popup"
            onCancel={modalCancelHandler}
            onClose={modalCancelHandler}
            buttonStyle={POPUP_BUTTON_STYLE.SIDEBYSIDE}
            popupHeading={t('viewInvoices.projectSelectPopUp.heading')}
            showPopupHeading={true}
            contentType="element"
            labelActionCancel={t('buttons.cancel')}
            labelActionOk={t('buttons.continue')}
            showCloseIcon={true}
            showPopupTitle={true}
            popupTitle={t('viewInvoices.projectSelectPopUp.title')}
            continueButtonState={projects?.selectedOption ? false : true}
            exitButtonHint={t('viewInvoices.projectSelectPopUp.cancelHint')}
            continueButtonHint={t(
              'viewInvoices.projectSelectPopUp.continueHint',
              {name: projectName ?? ''}
            )}
            cancelButtonTitle=""
            showOkOption={!initialProjectListLoading}
            showCancelOption={!initialProjectListLoading}
            popupContent={
              initialProjectListLoading ? (
                <AurLoadingIndicator
                  className="project-switch-modal-loader"
                  size={32}
                  show={initialProjectListLoading}
                />
              ) : (
                <AurClientDropdown
                  buttonOrTextField={'button'}
                  buttonLabel={t('viewInvoices.projectSelectPopUp.projectName')}
                  dropDownID={MODAL_PROJECT_DROP_DOWN_ID}
                  data={dropDownProjects}
                  idKey="projectId"
                  displayKey="projectName"
                  buttonBorderHighlight={true}
                  selectDefaultFirstItem={false}
                  initialSelectedOptionId={
                    pickedProjectFromDropdown.current?.projectId ??
                    selectedProject.id
                  }
                  onOptionPick={(projectId) => {
                    const project = dropDownProjects.find(
                      (p) => p.projectId === projectId
                    );
                    if (project) {
                      dispatch(
                        setModalDropDownSelectedItem({
                          id: project.projectId,
                          name: project.projectName,
                        })
                      );
                    }
                  }}
                  disableDropDownForSingleItem
                  hintToViewOnSelection={t('viewInvoices.invoiceBreadCrumb')}
                  onSearchInput={handleProjectSearch}
                  searchReqLoading={projectListLoading}
                  enableSearch={projectListSearchEnable}
                  onLoadMore={loadMoreProjects}
                  isLoadingMore={isLoadingMore}
                />
              )
            }
          />
        </div>
      </div>
      {
        <AurLoadingIndicator
          overlay={true}
          isOpen={
            (isGetInvoiceLoading && isGetAlertLoading) ||
            isDownloadInvoiceLoading
          }
        />
      }
    </div>
  );
};

export default ViewInvoices;
